import {Box} from '@mui/material';
import React from 'react';
import {useMediaQuery} from 'react-responsive';
import styles from './page-body.module.scss';

interface Props {
    justifyContent?: 'center' | 'flex-start';
    alignItems?: 'center' | 'flex-start' | 'stretch';
    setDefaultPadding?: boolean;
    className?: string;
    children: React.ReactNode;
}

export default function PageBody({ justifyContent = 'flex-start', alignItems = 'center', setDefaultPadding = true, className, children }: Props) {
    const isMobile = useMediaQuery({ maxWidth: 1000 });

    return (
        <Box
            className={[styles.pageBody, className].filter(Boolean).join(' ')}
            sx={{
                justifyContent,
                alignItems,
                overflowY: isMobile ? 'hidden' : 'auto',
                height: '100%',
                maxHeight: '100%',
                minHeight: 0,
                padding: !setDefaultPadding ? '0px' : (isMobile ? '12px' : '0 32px 16px')                
            }}>
            {children}
        </Box>
    );
}
